export enum betriebsanweisungArtenModel {
  SINGULAR = "BA-Art",
  PLURAL = "BA-Arten",
  ROUTE = "/betriebsanweisungArt",
  ICON = "mdi-cards-outline",
  ITEM_KEY = "betriebsanweisungArt",
  ITEM_KEY_UPDATE = "betriebsanweisungArten",
}
